import { useContext } from 'react'

import { AppContext } from 'Const'

export const useLocationIsUS = (): boolean => {
  const { currentLocation } = useContext(AppContext)
  return currentLocation?.address?.country === 'United States'
}
